export const exceptionsRoutes = {
    "/taskNotAvailable": "taskNotAvailable"
};
